



























































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Tenant, TenantUser } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef, Loading } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

export type CsvRow = {
  shopCode: string; //店舗コード
  scName: string; //店舗名
  ttcode: string; //TTコード
  kukakucode: string; //区画コード
  regino: string; //レジNo
  shopno: string; // 公式サイトショップ番号
  shopName: string; //ショップ名
  pickupEnabled: string; //MO利用(利用1)
  reservationEnabled: string; //来店予約利用(利用1)
  paidReservationEnabled: string; //有料来店予約利用(利用1)
  tenantId: string; //shopID
  [key: string]: string;
};
export interface ErrorRow {
  num: number;
  massage: string;
}

export default shopBase.extend(Vue).extend({
  name: "TenantCsv",
  mixins: [],
  async created() {
    await this.createCsvTable();
  },
  data() {
    return {
      authentication,
      transitionName: "",
      loading: new Loading(),
      hideBtn: true,
      tableColumn: [
        { label: "店舗コード", field: "shopCode", type: "string" },
        { label: "店舗名", field: "scName", type: "string" },
        { label: "TTコード", field: "ttcode", type: "string" },
        { label: "区画コード", field: "kukakucode", type: "string" },
        { label: "レジNO", field: "regino", type: "string" },
        { label: "公式サイトショップ番号", field: "shopno", type: "string" },
        { label: "ショップ名", field: "shopName", type: "string" },
        { label: "MO利用(利用1)", field: "pickupEnabled", type: "number" },
        {
          label: "来店予約利用(利用1)",
          field: "reservationEnabled",
          type: "number"
        },
        {
          label: "有料来店予約利用(利用1)",
          field: "paidReservationEnabled",
          type: "number"
        },
        { label: "shopID", field: "tenantId", type: "string" }
      ],
      tableData: [] as CsvRow[],
      errorTableColumn: [
        { label: "行数", field: "num", type: "string" },
        { label: "メッセージ", field: "massage", type: "string" }
      ],
      errorTableData: [] as ErrorRow[]
    };
  },
  computed: {
    tenant(): Collection<Tenant> {
      return new Collection(
        db.collection("tenant") as firestore.CollectionReference<Tenant>
      );
    },
    list(): List<Tenant> {
      return this.tenant.query({
        filter: {
          shopId: { $eq: this.shopId }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    }
  },
  methods: {
    downloadCsv() {
      const d = dayjs().format("YYYY-MM-DD");
      (window as any).jQuery("#csvTable .vgt-table").tableExport({
        type: "csv",
        preventInjection: false,
        csvEnclosure: "",
        csvEncoding: "utf-8",
        fileName: `Tenant-${d}`
      });
    },
    convertCsvStr(t: string) {
      return '"' + t.replaceAll('"', '""') + '"';
    },
    async createCsvTable() {
      this.list.ref.get().then(tenants => {
        tenants.forEach(doc => {
          this.tableData.push({
            shopCode: this.shop ? String(this.shop.data?.shopCode) : "",
            scName: this.shop
              ? String(this.shop.data?.name).replace("イオンタウン", "")
              : "",
            ttcode: doc.data().ttcode ? String(doc.data().ttcode) : "",
            kukakucode: doc.data().kukakucode
              ? String(doc.data().kukakucode)
              : "",
            regino: doc.data().regino ? String(doc.data().regino) : "",
            shopno: doc.data().shopno ? String(doc.data().shopno) : "",
            shopName: doc.data().shopName,
            pickupEnabled: doc.data().pickupEnabled ? "1" : "",
            reservationEnabled: doc.data().reservationEnabled ? "1" : "",
            paidReservationEnabled: doc.data().paidReservationEnabled
              ? "1"
              : "",
            tenantId: doc.id
          });
        });
        for (let i = 0; i < this.tableData.length; i++) {
          for (const key in this.tableData[i]) {
            if (
              key == "shopCode" ||
              key == "kukakucode" ||
              key == "regino" ||
              key == "shopno"
            ) {
              this.tableData[i][key] =
                "=" + this.convertCsvStr(this.tableData[i][key]);
            } else {
              this.tableData[i][key] = this.convertCsvStr(
                this.tableData[i][key]
              );
            }
            //this.tableData[i][key] = this.convertCsvStr(this.tableData[i][key]);
          }
        }
        this.tableData.sort(function(a, b) {
          //shopCodeの昇順
          if (a.shopCode > b.shopCode) return 1;
          if (a.shopCode < b.shopCode) return -1;
          //reginoの昇順
          if (a.regino > b.regino) return 1;
          if (a.regino < b.regino) return -1;
          //shopnoの昇順
          if (a.shopno > b.shopno) return 1;
          if (a.shopno < b.shopno) return -1;
          return 0;
        });
        this.hideBtn = false;
      });
    },
    selectCsv() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    async uploadFile(event: Event) {
      this.errorTableData = [];
      if (event.target instanceof HTMLInputElement) {
        console.log("uploadFile", event.target.files);
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択してください。"
          });
          event.target.value = "";
        } else {
          event.target.files.forEach((item: File) => {
            const reader = new FileReader();
            reader.onload = async () => {
              this.loading.run(async () => {
                if (!reader.result || typeof reader.result != "string") {
                  return;
                }
                //console.log('reader.result',reader.result);
                let result = reader.result;
                result = result.replace(/="(\d+)"/g, '"=""$1"""');
                result = result.replace(/="",/g, '"=""""",');
                console.log("replace.result", result);
                const csv = (window as any).jQuery.csv.toArrays(result);
                console.log(csv);
                // CSVバリデーション
                await this.validationCsv(csv);
                if (this.errorTableData.length > 0) {
                  alert({
                    title: "エラー",
                    text:
                      "CSVが不正な値があります。エラー内容を確認してください。"
                  });
                } else {
                  for (let i = 0; i < csv.length; i++) {
                    if (i == 0) {
                      continue;
                    }
                    const line = csv[i];
                    const csvData = this.convertCsvLine(line);
                    const tenantId = csvData.tenantId;
                    const data = {
                      ttcode: csvData.ttcode,
                      kukakucode: csvData.kukakucode.replace(/=|"/g, ""),
                      regino: csvData.regino.replace(/=|"/g, "")
                    };
                    //const oldData = await this.tenant.doc(tenantId, { noListen: true }).ref?.get();
                    const updateData = {
                      ...data,
                      updateTime: Date.now()
                    };
                    await db.doc(`/tenant/${tenantId}`).update(updateData);
                    console.log("updateData", updateData);
                  }
                  alert({
                    title: "完了",
                    text: "CSV取り込みが完了しました。"
                  });
                }
              });
            };
            reader.readAsText(item);
          });
          event.target.value = "";
        }
      }
    },
    async validationCsv(csv: any) {
      for (let i = 0; i < csv.length; i++) {
        const line = csv[i];
        if (this.tableColumn.length != line.length) {
          this.errorTableData.push({
            num: i + 1,
            massage: "列数が指定と異なります。"
          });
          continue;
        }
        if (i == 0) {
          // ヘッダーチェック
          for (let j = 0; j < this.tableColumn.length; j++) {
            const column = this.tableColumn[j];
            if (column.label != line[j]) {
              this.errorTableData.push({
                num: i + 1,
                massage: "ヘッダー行が指定と異なります。"
              });
              break;
            }
          }
        } else {
          const csvData = this.convertCsvLine(line);
          if (!csvData.tenantId) {
            this.errorTableData.push({
              num: i + 1,
              massage: "shopIDが指定されていません。"
            });
          } else {
            const oldData = await this.tenant
              .doc(csvData.tenantId, { noListen: true })
              .ref?.get();
            if (!oldData?.exists) {
              this.errorTableData.push({
                num: i + 1,
                massage:
                  "shopIDが指定されていますが、更新対象のデータがみつかりません。"
              });
            }
          }
          if (csvData.ttcode) {
            const regex = /^TT00[0-9]{6}$/;
            if (!regex.test(csvData.ttcode)) {
              this.errorTableData.push({
                num: i + 1,
                massage:
                  "TTコードのフォーマットが正しくありません。" + csvData.ttcode
              });
            }
          }
          if (csvData.kukakucode && csvData.kukakucode != '=""') {
            console.log("error csvData.kukakucode", csvData.kukakucode);
            const regex = /^="[0-9]{2}"$/;
            if (!regex.test(csvData.kukakucode)) {
              this.errorTableData.push({
                num: i + 1,
                massage:
                  "区画コードのフォーマットが正しくありません。" +
                  csvData.kukakucode
              });
            }
          }
          if (csvData.regino && csvData.regino != '=""') {
            const regex = /^="[0-9]{3}"$/;
            if (!regex.test(csvData.regino)) {
              console.log("error csvData.regino", "a" + csvData.regino + "b");
              this.errorTableData.push({
                num: i + 1,
                massage:
                  "レジNoのフォーマットが正しくありません。" + csvData.regino
              });
            }
          }
        }
      }
    },
    convertCsvLine(line: any) {
      const result = {
        shopCode: line[0],
        scName: line[1],
        ttcode: line[2],
        kukakucode: line[3],
        regino: line[4],
        shopno: line[5],
        shopName: line[6],
        pickupEnabled: line[7],
        reservationEnabled: line[8],
        paidReservationEnabled: line[9],
        tenantId: line[10]
      };
      return result;
    }
  }
});
